<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> اخبار </span>

    </div>

</div>


<!-- اطلاعات دریافت شده  -->

<main style="direction: rtl;" class="py-3 px-2">

    <!-- نمایش اطلاعات -->

    <div class="row gx-0 gy-2 gx-md-2 gy-md-2 border border-2 rounded p-2">

        <!-- سرچ باکس -->

        <div class="col-12 col-md-10 searchbox-container">

            <input class="w-100 form-control" placeholder="جستجو کنید ..."> 

        </div>

        <!-- افزودن -->

        <div class="col-12 col-md-auto add-button-container">

            <button class="btn btn-success" (click)="openModal()"> 
                
                &nbsp; &nbsp; افزودن &nbsp; &nbsp; 
            
            </button>
            
        </div>

        <!-- جدول اطلاعات -->

        <div class="col-12 section border border-2 mt-3" style="height:calc(100vh - 150px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="col-12 text-center">
        
                        <th class="text-center col-1"> # </th>

                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> عنوان </th>
            
                        <th class="text-center"> تاریخ اعتبار </th>

                        <th class="text-center"> مهم</th>

                        <th class="text-center"> اختصاصی راننده </th>

                        <th class="text-center"> بایگانی</th>


                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_News;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td>
                            
                            <i class="fa fa-edit fa-lg mx-2 text-primary pointer" title=" ویرایش" (click)="openModal(true,item,i)"></i>

                            <i class="fa fa-trash fa-lg text-danger pointer" title="حذف" (click)="removeNews(item,i)"></i>
                            
                        </td>

                        <td>{{ item.strTitle}}</td>
    
                        <td>{{ item.strDateTime | faNum}}</td>

                        <td>{{ item.bImportant ? 'بله' : 'خیر' }}</td>

                        <td>{{ item.b4Driver ? 'بله' : 'خیر' }}</td>

                        <td>{{ item.bArchive ? 'بله' : 'خیر' }}</td>

                    </tr>

                </tbody>

            </table>

        </div>


    </div>

</main>


<!-- افزودن , ویرایش خبر -->

<div class="modal fade" id="News_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMode ? 'ویرایش خبر جدید' : 'ثبت خبر جدید' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_News" class="container-fluid row gx-2 gy-2 p-2">

                    <!-- عنوان خبر -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> عنوان خبر </label>
            
                        <input class="form-control p-2 text-start" formControlName="strTitle">
            
                    </div>

                    <!-- تاریخ انتشار -->
            
                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> تاریخ انتشار </label>
            
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
            
                            <input formControlName="strDateTime" class="form-control p-2 text-center" />
            
                        </ng-persian-datepicker>
            
                    </div>

                    <!-- تاریخ اعتبار -->
            
                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> تاریخ اعتبار </label>
            
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
            
                            <input formControlName="strValidateDateAndTime" class="form-control p-2 text-center" />
            
                        </ng-persian-datepicker>
            
                    </div>
                    
                    <!-- راننده -->
                     
                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

                        <input class="form-check-input m-0" type="checkbox" id="b4Driver" formControlName="b4Driver">
                    
                        <label class="form-check-label pointer text-muted me-2" for="b4Driver"> اختصاصی راننده </label>
                    
                    </div>

                    <!-- اهمیت -->
                     
                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bImportant" formControlName="bImportant">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bImportant"> خبر مهم </label>
                    
                    </div>

                    <!-- بایگانی -->
                     
                    <div *ngIf="bEditMode" class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bArchive" formControlName="bArchive">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bArchive"> بایگانی </label>
                    
                    </div>

                    <!-- نمایش تصویر بارگذاری شده -->

                    <ng-container *ngIf="mdl_News.get('strImage')?.value != ''">

                        <div class="d-flex justify-content-center p-2" >

                            <div class="img-popup-container" style="max-width: 300px;max-height: 200px;">

                                <img src="{{ mdl_News.get('strImage')?.value != '' ? 'data:image/jpg;base64,' + mdl_News.get('strImage')?.value : '../../../../assets/imgs/preview__thumbnail.png' }}" style="max-width: 100%;max-height: 100%;" alt="">
            
                                <div class="close-popup">

                                    <i class="fa fa-times fa-lg pointer" (click)="mdl_News.get('strImage').value = '' "></i>
                                    
                                </div>
            
                            </div>

                        </div>

                    </ng-container>

                    <!-- آپلود تصویر -->

                    <div class="col-12 d-flex justify-content-center align-items-center">

                        <label for="uploader" class="d-flex justify-content-center align-items-center flex-column w-100 custom-file-upload">
    
                            <div class="d-flex flex-column justify-content-center align-items-center">
    
                                <i class="fa fa-upload fa-lg mx-2 mb-1" aria-hidden="true"></i>
    
                                <small> افزودن تصویر </small>
    
                            </div>
    
                            <small class="mt-1"> فرمت تصویر می تواند jpg یا gif باشد. </small>
    
                        </label>
    
                        <input accept="image/jpeg, image/gif" class="d-none" type="file" id="uploader" (change)="onUpload($event)">
    
                    </div>

                    <!-- ادیتور -->

                    <div class="col-12 border border-2" >

                        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>

                        <ngx-editor [editor]="editor" formControlName="strContent" [placeholder]="' متن خود را وارد کنید .... '"></ngx-editor>

                    </div>

            
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn" [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' " (click)="news_Submit()">

                    &nbsp; &nbsp; {{ bEditMode ? 'ویرایش' : 'ذخیره' }} &nbsp; &nbsp;

                </button>


                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>